import { Observable, BehaviorSubject } from 'rxjs';
import { RankSortingLocatorComponent } from 'world-archery-lib';



/**
 * This is an abstract class that every filter silver must implement on a wa-app
 *
 * @export
 * @abstract
 * @class FiltersAbstractService
 * @template T
 */
export abstract class FiltersAbstractService<T= any> {

  /**
   * This is the variable that contain an Array of filters
   *
   * @type {*}
   * @memberof FiltersAbstractService
   */
  filtersType: any = [];

  /**
   * This is the property that stores the data of sorting in a table
   *
   * @memberof FiltersAbstractService
   */
  readonly sortLocator = new RankSortingLocatorComponent();

  /**
   * This is the subject into the class that receives a new sort element
   *
   * @protected
   * @type {BehaviorSubject<
   *     RankSortingLocatorComponent
   *   >}
   * @memberof FiltersAbstractService
   */
  protected orderSubject: BehaviorSubject<
    RankSortingLocatorComponent
  > = new BehaviorSubject(this.sortLocator);

  constructor(
    defaultCall?:boolean
  ) {
    defaultCall === true ? this.generateDefaultValues() : undefined;
    this.sortLocator.asc = true;
  }

  /**
   * This is a method for get the observable value of sorting
   *
   * @readonly
   * @type {Observable<RankSortingLocatorComponent>}
   * @memberof FiltersAbstractService
   */
  get orderValue(): Observable<RankSortingLocatorComponent> {
    return this.orderSubject.asObservable();
  }

  /**
   * This is a method that must be callen when the sort data change
   *
   * @memberof FiltersAbstractService
   */
  public modifyOrderValue() {
    this.orderSubject.next(this.sortLocator);
  }

 /**
 * Get default date for filters.
 *
 * @return Date
 *   From now.
 */
  getDateDefault() {
    const date = new Date(), y = date.getFullYear(), m = date.getMonth();
    return { value: date };
  }

  /**
   * This is a method used to generate or change the default values
   *
   * @abstract
   * @memberof FiltersAbstractService
   */
  abstract generateDefaultValues(): void

  /**
   * This is a method used for get the stream of filters
   *
   * @abstract
   * @returns {Observable<T>}
   * @memberof FiltersAbstractService
   */
  abstract getDataStreamWithFilters(): Observable<T>
}
